export const coordinates = {
  async: false,
  validate: function(data: any, field: any) {
    data = data.original
    if (!data[field]) return true
    if (
      Number(data[field].replace(",", ".")) &&
      Number(data[field].replace(",", "."))
    ) {
      return true
    } else {
      throw Error("Insira um formato de coordenada valido ex: -42.345643")
    }
  },
}
